import React, { useState } from 'react';
import './OurPlatformReachSection.css';

const accordionItems = [
  {
    title: 'Who the Traveler Is',
    description:
      'Our traveler journeys with intention—shaped by who they are, where they are in life, and what matters most in the moment. Every trip has a purpose, every choice reflects their values, and every experience needs to feel personally relevant.',
    tone: 'orange',
  },
  {
    title: 'What Travelers Care About',
    description: 'Ease, comfort, discovery, reward. Priorities shift as the journey unfolds. These moments of intent shape every decision, creating opportunities for brands to connect in ways that feel relevant, not interruptive.',
    tone: 'blue',
  },
  {
    title: 'How They Move and Engage',
    description: 'Between screens, spaces, and experiences, engagement is constant and in motion. These behaviors reveal where attention lives and create opportunities for brands to show up with relevance.',
    tone: 'dark',
  },
];

const ArrowIcon = ({ expanded }) => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d={expanded ? 'M12 19V5M5 12L12 5L19 12' : 'M12 5V19M5 12L12 19L19 12'}
      stroke='#171717'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const OurPlatformReachSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className='od-reach-section'>
      <div className='od-reach-intro'>
        <h2 className='od-reach-title'>Travel Moves People Out of Routine and Into Possibility</h2>

        <p className='od-reach-description'>
          With a wealth of unique enablers, our audiences are built on three dimensions that deeply
          understand guest preferences, capture identity, and real-world behavior.
        </p>
      </div>

      <div className='od-reach-accordion'>
        {accordionItems.map((item, index) => {
          const expanded = activeIndex === index;
          const contentId = `od-reach-card-content-${index}`;

          return (
            <article
              key={item.title}
              className={`od-reach-card od-reach-card--${item.tone} ${expanded ? 'is-expanded' : ''}`}
            >
              <button
                type='button'
                className='od-reach-card-trigger'
                onClick={() => setActiveIndex(index)}
                aria-expanded={expanded}
                aria-controls={contentId}
              >
                <span className='od-reach-card-title'>{item.title}</span>
                <span className='od-reach-card-icon'>
                  <ArrowIcon expanded={expanded} />
                </span>
              </button>

              <div
                id={contentId}
                className={`od-reach-card-content ${expanded ? 'is-expanded' : ''}`}
              >
                <div className='od-reach-card-content-inner'>
                  <p className='od-reach-card-description'>{item.description}</p>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default OurPlatformReachSection;
